import { getDecryptDataFromLocal } from '../../../utils/encrypt';

// Who sees Profile → "Publish CRM Updates". Server-enforced too: keep in sync
// with PUBLISHER_PHONES in manijment-api services/ai-service/crmAnnouncements.js.
export const CRM_UPDATE_PUBLISHERS = ['9719836187'];

export const isCrmUpdatePublisher = () => {
    try {
        const digits = String(getDecryptDataFromLocal('phoneNumber') || '').replace(/[^0-9]/g, '');
        return CRM_UPDATE_PUBLISHERS.includes(digits.slice(-10));
    } catch (e) { return false; }
};

// Fired after a publish/edit so the strip refetches without waiting for its poll.
export const CRM_UPDATES_CHANGED = 'crm-updates-changed';

export const ROLE_OPTIONS = [
    { value: 1, label: 'Admin' },
    { value: 2, label: 'Ops' },
    { value: 3, label: 'Finance' },
    { value: 4, label: 'Inventory' },
    { value: 5, label: 'Sales' },
    { value: 6, label: 'HR' },
    { value: 7, label: 'Trainer' },
    { value: 8, label: 'FC' },
    { value: 9, label: 'Common' },
    { value: 10, label: 'Data Entry' },
    { value: 11, label: 'Warehouse Inventory' },
    { value: 12, label: 'Minimal Access' },
    { value: 13, label: 'Team Lead' },
    { value: 14, label: 'Floor Manager' },
    { value: 15, label: 'Lead Entry' },
    { value: 16, label: 'Content Team' },
    { value: 17, label: 'Sales Manager' },
    { value: 18, label: 'Asst. Sales Manager' },
    { value: 19, label: 'Packer' }
];

export const SEGMENT_OPTIONS = [
    { value: 'whatsapp', label: 'WhatsApp team' },
    { value: 'cohort', label: 'Cohort agents' },
    { value: 'nonCohort', label: 'Non-cohort agents' }
];
